import { useState } from "react";
import { useSeo } from "~/lib/seo/useSeo";
import { BriefForm } from "~/ui/Hire/BriefForm";
import { ContactAlternatives } from "~/ui/Hire/ContactAlternatives";
import { ThankYou } from "~/ui/Hire/ThankYou";

type Estado = "parado" | "enviado";

export function Hire() {
  useSeo({
    title: "Contato",
    description:
      "Conte o que você precisa construir: área, faixa de orçamento, prazo e o problema. João responde em até 24 horas.",
    pathname: "/hire",
  });
  const [estado, setEstado] = useState<Estado>("parado");

  return (
    <section className="jg-shell pb-24 pt-12 sm:pt-16">
      <p className="jg-eyebrow">Contato</p>

      <h1 className="mt-5 max-w-[16ch] font-display text-[clamp(2rem,5.5vw,3.2rem)] font-medium leading-[1.08] tracking-[-0.02em]">
        Me conte o problema, não a solução.
      </h1>

      <p className="mt-6 max-w-[56ch] text-[length:var(--text-step-0)] leading-[1.55] text-jg-fg-muted">
        Nome e e-mail para eu responder, uma faixa de orçamento e um prazo
        para eu ser honesto sobre encaixe, e o máximo de detalhe que você
        puder sobre o problema de verdade. Respondo em até 24 horas, mesmo
        quando a resposta é que não sou a pessoa certa.
      </p>

      <div className="mt-14 border-t border-jg-rule pt-10">
        {estado === "enviado" ? (
          <ThankYou onReset={() => setEstado("parado")} />
        ) : (
          <BriefForm onSubmitted={() => setEstado("enviado")} />
        )}
      </div>

      <div className="mt-16 border-t border-jg-rule pt-8">
        <p className="jg-eyebrow">Ou pule o formulário</p>
        <div className="mt-5">
          <ContactAlternatives />
        </div>
      </div>
    </section>
  );
}
